/** */
const REACT_APP_ENV = process.env.REACT_APP_ENV;

const app_config = {
  development: {
    ai: 'http://localhost:4023',
    api: 'http://localhost:4018',
    app: 'http://localhost:3000',
    editor: 'http://localhost:3003',
    files: 'http://localhost:4010',
    iam: 'http://localhost:4011',
    landing: 'http://localhost:3001',
    mailing: 'http://localhost:4017',
    mailometric: 'http://localhost:4002',
    messaging: 'http://localhost:4014',
    mobi_push: 'http://localhost:4020',
    reports: 'http://localhost:4012',
    sales: 'http://localhost:4003',
    users: 'http://localhost:4001',
    whatsapp: 'http://localhost:4024',
    notification: 'http://localhost:4007',
    automata: 'http://localhost:4016',
    terms: 'http://localhost:3001/terms',
    policy: 'http://localhost:3001/privacy'
  },
  testing: {
    ai: 'https://ai.gm-g6.xyz',
    api: 'https://api.gm-g6.xyz',
    app: 'https://app.gm-g6.xyz',
    editor: 'https://editor.gm-g6.xyz',
    files: 'https://files.gm-g6.xyz',
    iam: 'https://iam.gm-g6.xyz',
    landing: 'https://gm-g6.xyz',
    mailing: 'https://mails.gm-g6.xyz',
    mailometric: 'https://mailometric.gm-g6.xyz',
    messaging: 'https://messaging.gm-g6.xyz',
    mobi_push: 'https://mobi-push.gm-g6.xyz',
    reports: 'https://reports.gm-g6.xyz',
    sales: 'https://sales.gm-g6.xyz',
    users: 'https://users.gm-g6.xyz',
    whatsapp: 'https://whatsapp.gm-g6.xyz',
    notification: 'https://notification.gm-g6.xyz',
    automata: 'https://automation.gm-g6.xyz',
    terms: 'https://gm-g6.xyz/terms',
    policy: 'https://gm-g6.xyz/privacy'
  },
  staging: {
    ai: 'https://ai.gm-g7.xyz',
    api: 'https://api.gm-g7.xyz',
    app: 'https://app.gm-g7.xyz',
    editor: 'https://editor.gm-g7.xyz',
    files: 'https://files.gm-g7.xyz',
    iam: 'https://iam.gm-g7.xyz',
    landing: 'https://gm-g7.xyz',
    mailing: 'https://mails.gm-g7.xyz',
    mailometric: 'https://mailometric.gm-g7.xyz',
    messaging: 'https://messaging.gm-g7.xyz',
    mobi_push: 'https://mobi-push.gm-g7.xyz',
    reports: 'https://reports.gm-g7.xyz',
    sales: 'https://sales.gm-g7.xyz',
    users: 'https://users.gm-g7.xyz',
    whatsapp: 'https://whatsapp.gm-g7.xyz',
    notification: 'https://notification.gm-g7.xyz',
    automata: 'https://automation.gm-g7.xyz',
    terms: 'https://gm-g7.xyz/terms',
    policy: 'https://gm-g7.xyz/privacy'
  },
  production: {
    ai: 'https://ai.go-mailer.com',
    api: 'https://api.go-mailer.com',
    app: 'https://app.go-mailer.com',
    editor: 'https://editor.go-mailer.com',
    files: 'https://files.go-mailer.com',
    iam: 'https://iam.go-mailer.com',
    landing: 'https://go-mailer.com',
    mailing: 'https://mails.go-mailer.com',
    mailometric: 'https://mailometric.go-mailer.com',
    messaging: 'https://messaging.go-mailer.com',
    mobi_push: 'https://mobi-push.go-mailer.com',
    reports: 'https://reports.go-mailer.com',
    sales: 'https://sales.go-mailer.com',
    users: 'https://users.go-mailer.com',
    whatsapp: 'https://whatsapp.go-mailer.com',
    notification: 'https://notification.go-mailer.com',
    automata: 'https://automation.go-mailer.com',
    terms: 'https://go-mailer.com/terms',
    policy: 'https://go-mailer.com/privacy'
  }
};

export const urls = { ...app_config[REACT_APP_ENV || 'development'] };
